export const Search = ({ color = "#0E0E0E" }: { color?: string }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="11.5" cy="10.5" r="6.75" stroke={color} strokeWidth="1.5" />
			<line
				x1="18.0607"
				y1="17"
				x2="20"
				y2="18.9393"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	);
};
